export default {
  pageTitle: 'Special Type',
  specialCode: 'Special Code',
  specialType: 'Special Type',
  exceptionType: 'Exception Type',
  lastUpdatedBy: 'Last Updated By',
  lastUpdateTime: 'Last Update Time',
  disableConfirmSimple: 'Are you sure to disable the Special Code?',
  disableConfirmLinkedPrefix:
    'The following products are linked to this special type. Disabling it will remove the special status from these products.',
  mandatoryFields: 'Please complete all required fields before creating a new site.',
  errorcode_6001:
    'The Special code already exists. Please search for it on the page before making any edits or updates.',
  errorcode_6004: 'The Special code already exists. Please input a new code.',
  selectData: 'Please select the data to disable.'
}
